import { OnInit, ElementRef, Renderer2, OnDestroy, AfterViewInit } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { ViewService } from 'src/app/view/view.service';
import { Actions } from '@ngxs/store';
import { debounceTime, takeUntil } from 'rxjs/operators';
var PlayLoaderComponent = /** @class */ (function () {
    // ---------- Lifecycle ----------
    function PlayLoaderComponent(renderer, viewService, actions) {
        this.renderer = renderer;
        this.viewService = viewService;
        this.actions = actions;
        this.ngUnsubscribe = new Subject();
        this._percent = 0;
    }
    Object.defineProperty(PlayLoaderComponent.prototype, "percent", {
        // ---------- Inputs ----------
        get: function () {
            return this._percent;
        },
        set: function (value) {
            if (value == null) {
                return;
            }
            this._percent = value;
            this.setProgress(this.percent);
        },
        enumerable: true,
        configurable: true
    });
    PlayLoaderComponent.prototype.ngOnInit = function () {
        this.initSizeObserver();
    };
    PlayLoaderComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    PlayLoaderComponent.prototype.ngAfterViewInit = function () {
        this.updateDimensions();
        this.initCircle();
    };
    // ---------- Class Methods ----------
    PlayLoaderComponent.prototype.initSizeObserver = function () {
        var _this = this;
        // Listen to view page resize
        var windowResize$ = fromEvent(window, 'resize');
        windowResize$
            .pipe(debounceTime(10), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.updateDimensions();
        });
    };
    PlayLoaderComponent.prototype.calculateRadius = function () {
        return this.getCircleWidth() / 2;
    };
    PlayLoaderComponent.prototype.getCircleWidth = function () {
        return this.circleRef.nativeElement.offsetWidth;
    };
    PlayLoaderComponent.prototype.getRadius = function () {
        return this.progressCircleRef.nativeElement.r.baseVal.value;
    };
    PlayLoaderComponent.prototype.getCircumference = function () {
        var radius = this.getRadius();
        return radius * 2 * Math.PI;
    };
    PlayLoaderComponent.prototype.getOffset = function (percent) {
        if (percent === void 0) { percent = 100; }
        var circumference = this.getCircumference();
        return circumference - percent / 100 * circumference;
    };
    PlayLoaderComponent.prototype.setProgress = function (percent) {
        if (percent >= 100) {
            percent = 100;
        }
        var circumference = this.getCircumference();
        var offset = this.getOffset(percent);
        this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDasharray', circumference + " " + circumference);
        this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDashoffset', "" + offset);
    };
    PlayLoaderComponent.prototype.initCircle = function () {
    };
    PlayLoaderComponent.prototype.updateDimensions = function () {
        var radius = this.calculateRadius();
        this.renderer.setAttribute(this.progressContainerRef.nativeElement, 'width', "" + radius * 2);
        this.renderer.setAttribute(this.progressContainerRef.nativeElement, 'height', "" + radius * 2);
        this.renderer.setAttribute(this.progressCircleRef.nativeElement, 'r', "" + (radius - 6));
        this.renderer.setAttribute(this.progressCircleRef.nativeElement, 'cx', "" + radius);
        this.renderer.setAttribute(this.progressCircleRef.nativeElement, 'cy', "" + radius);
        var circumference = this.getCircumference();
        this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDasharray', circumference + " " + circumference);
        this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDashoffset', "" + circumference);
    };
    return PlayLoaderComponent;
}());
export { PlayLoaderComponent };
